(function ($) {

    $.fn.ratingControl = function (options) {

        var rated = false;
        var ratingHtmlData;

        var $base = this;

        var settings = $.extend({
            // These are the defaults.
            enabled: true,
            showDetails: false,
            callback: function () { }
        }, options);


        $('.ratingcontrols', $base).show();

        $('.rating', $base).rating({
            callback: function (value, link) {
                var serviceUrl = $(this).data('url');
                if (!rated) {
                    $.ajax({
                        type: "POST",
                        async: true,
                        dataType: "json",
                        url: serviceUrl,
                        data: "action=rating&rating=" + value,
                        success: function (data) {

                            if (data) {
                                rated = true;
                                var ratingText = "(" + data.TotalRatings + " ";
                                ratingText += "Bewertung" + (data.TotalRatings == 1 ? "" : "en");
                                ratingText += ")";

                                $('.ratingLink', $base).text(ratingText);

                                $('.rating', $base).rating('select', data.AverageRating-1); // -1 because of Index
                                $('.rating', $base).rating('readOnly', true);

                                $.each(data.RatingModels, function (i, item) {
                                    var range = item.Range;
                                    var target = $("span[data-id='" + range + "']", $base);
                                    target.css('width', item.PercentWidth);
                                    target.next('.text').html(item.PercentText);

                                    var desc = $("span[data-desc='" + range + "']", $base);
                                    desc.html(item.DisplayText);
                                });

                                settings.callback();
                                
                                if ($.isFunction(userRated)) {
                                    userRated();
                                }
                            }
                        }
                    });
                }
            }
        });

        if (!settings.enabled) {
            $('.rating', $base).rating('readOnly', true);
            rated = true;
        }

        $(".ratingLink", $base).on('click', function (e) {
            e.preventDefault();
            $('.ratingDetailView', $base).slideToggle();
        });

        if (settings.showDetails) {
            $('.ratingDetailView', $base).show();
        }
    };

}(jQuery));